var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar, Row, Col } from 'react-bootstrap';
import StatBox from './StatBox';
import './StatBoxWithPercentage.css';
var StatBoxWithPercentage = function StatBoxWithPercentage(_ref) {
    var variant = _ref.variant,
        percentage = _ref.percentage,
        rest = _objectWithoutProperties(_ref, ['variant', 'percentage']);

    return React.createElement(
        StatBox,
        _extends({ className: 'shadow rounded-0 statbox-percentage' }, rest, { variant: variant, footerComponent: React.createElement(
                Row,
                { noGutters: true },
                React.createElement(
                    Col,
                    null,
                    React.createElement(ProgressBar, { className: 'flex-row-reverse rounded-0 progress-bottom bg-white', variant: 'danger', now: percentage < 0 ? percentage * -1 : 0, key: 2 })
                ),
                React.createElement(
                    Col,
                    null,
                    React.createElement(ProgressBar, { className: 'rounded-0 progress-bottom bg-white', variant: 'success', now: percentage > 0 ? percentage : 0, key: 1 })
                )
            )
        }),
        React.createElement(
            'p',
            { className: 'text-' + (percentage < 0 ? 'danger' : percentage > 0 ? 'success' : 'info') },
            percentage,
            '%'
        )
    );
};

StatBoxWithPercentage.propTypes = process.env.NODE_ENV !== "production" ? {
    number: PropTypes.number.isRequired,
    variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'success', 'info', 'danger', 'warning']),
    title: PropTypes.string,
    percentage: PropTypes.number
} : {};
export default StatBoxWithPercentage;